module.exports = __webpack_public_path__ + "static/media/markus-spiske-2G8mnFvH8xk-unsplash.b478c216.jpg";